var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal--form modal-form"},[_c('div',{staticClass:"modal-form__form"},[_c('form-form',{attrs:{"form":_vm.formString}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }